// removed by extract-text-webpack-plugin
module.exports = {"button_add":"_1-ZO4MkArnkyVN9ZQgHh_b"};